import { render, staticRenderFns } from "./custom-form-brand.vue?vue&type=template&id=ae28f258&scoped=true&"
import script from "./custom-form-brand.vue?vue&type=script&lang=js&"
export * from "./custom-form-brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae28f258",
  null
  
)

export default component.exports